
// import React, { useEffect, useState,useRef } from "react";
// import axios from "axios";
// import { API_PATH } from "../../Constant/constant";
// import { useNavigate } from "react-router-dom";
// import * as Constants from "../../Constant/constant";
// import  UserCard from './Cards'
// import { useReactToPrint } from "react-to-print";

// const PAGE_SIZE = 10;

// const FilterRow = ({ filters, setFilters }) => (
//   <tr className="libraryCard mt-20">
//     <td></td>
//     <td>
//       <input
//         type="text"
//         placeholder="Name"
//         value={filters.name}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, name: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Email"
//         value={filters.email}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, email: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Mobile"
//         value={filters.mobile}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, mobile: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Unique ID"
//         value={filters.unique_id}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, unique_id: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Library Name"
//         value={filters.library_id}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, library_id: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td></td>
//   </tr>
// );

// const LibraryUsersList = () => {
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [filters, setFilters] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     unique_id: "",
//     library_id: "",
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const navigate = useNavigate();
//   const [libraries, setLibraries] = useState([]);
//    const [selectedUser, setSelectedUser] = useState(null);

//   // Fetch all users
//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const res = await axios.get(`${API_PATH}/library_cards`);
//         setUsers(res.data);
//         setFilteredUsers(res.data);
//       } catch (err) {
//         console.error("❌ Error fetching users:", err);
//         setError("Failed to load users");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsers();
//   }, []);

//   // Fetch libraries once
//   useEffect(() => {
//     const fetchLibraries = async () => {
//       try {
//         const response = await axios.get(
//           Constants.API_PATH + `/add_new_library_data`
//         );
//         setLibraries(response.data);
//       } catch (error) {
//         console.error("Error fetching libraries:", error);
//         setError("Failed to fetch libraries.");
//       }
//     };

//     fetchLibraries();
//   }, []);

//   // Apply filters
//   useEffect(() => {
//     let filtered = users;

//     if (filters.name) {
//       filtered = filtered.filter((u) =>
//         `${u.first_name} ${u.last_name}`
//           .toLowerCase()
//           .includes(filters.name.toLowerCase())
//       );
//     }

//     if (filters.email) {
//       filtered = filtered.filter(
//         (u) =>
//           u.email &&
//           u.email.toLowerCase().includes(filters.email.toLowerCase())
//       );
//     }

//     if (filters.mobile) {
//       filtered = filtered.filter(
//         (u) =>
//           u.mobile_no &&
//           u.mobile_no.toString().includes(filters.mobile.toString())
//       );
//     }

//     if (filters.unique_id) {
//       filtered = filtered.filter(
//         (u) =>
//           u.unique_id &&
//           u.unique_id.toLowerCase().includes(filters.unique_id.toLowerCase())
//       );
//     }

//     if (filters.library_id) {
//       filtered = filtered.filter(
//         (u) =>
//           u.library_id &&
//           u.library_id.toString().toLowerCase().includes(filters.library_id.toLowerCase())
//       );
//     }

//     setFilteredUsers(filtered);
//     setCurrentPage(1);
//   }, [filters, users]);

//   const totalPages = Math.ceil(filteredUsers.length / PAGE_SIZE);
//   const paginatedUsers = filteredUsers.slice(
//     (currentPage - 1) * PAGE_SIZE,
//     currentPage * PAGE_SIZE
//   );

//   if (loading) return <p className="text-gray-500">Loading users...</p>;
//   if (error) return <p className="text-red-600">{error}</p>;

//   const getLibraryName = (id) => {
//     const lib = libraries.find((library) => library.id === id);
//     return lib ? lib.library_name : "Unknown Library";
//   };

//  const printLibraryCard = (user) => {
//     setSelectedUser(user);
//     setTimeout(() => {
//       handlePrint();
//     }, 200);
//   };


//   const printRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: "Library Card",
//   });


//   return (
//     <div className="container w-80 mw-80">
//       <h2 className="text-xl font-bold mb-4">📚 All Users</h2>
//       {filteredUsers.length === 0 ? (
//         <p className="text-gray-600">No users found.</p>
//       ) : (
//         <>
//           <table className="w-100 table-bordered border-collapse border shadow-md rounded-lg overflow-hidden">
//             <thead>
//               <tr className="bg-blue-600 text-white libraryCard">
//                 <th className="px-4 py-2">#</th>
//                 <th className="px-4 py-2">Name</th>
//                 <th className="px-4 py-2">Email</th>
//                 <th className="px-4 py-2">Mobile</th>
//                 <th className="px-4 py-2">Unique ID</th>
//                 <th className="px-4 py-2">Library Name</th>
//                 <th className="px-4 py-2">Actions</th>
//               </tr>
//               <FilterRow filters={filters} setFilters={setFilters} />
//             </thead>
//             <tbody>
//               {paginatedUsers.map((u, index) => (
//                 <tr key={u.id} className="hover:bg-gray-50">
//                   <td className="border border-gray-300 px-4 py-2">
//                     {(currentPage - 1) * PAGE_SIZE + index + 1}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.first_name} {u.last_name}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">{u.email}</td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.mobile_no}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.unique_id}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {getLibraryName(u.library_id)}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2 text-center">
//                     <button
//                       onClick={() => navigate(`/library-cards/${u.id}`)}
//                       className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 "
//                     >
//                       View Card
//                     </button>

//                        <button
//                       onClick={() => printLibraryCard(u)}
//                       className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
//                     >
//                       Print Card
//                     </button>
                    
                    


//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="flex justify-center items-center mt-4 gap-2">
//             <button
//               className="px-2 py-1 border rounded"
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage(currentPage - 1)}
//             >
//               Prev
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               className="px-2 py-1 border rounded"
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage(currentPage + 1)}
//             >
//               Next
//             </button>
//           </div>

//             <div style={{ display: "none" }}>
//             {selectedUser && (
//               <div ref={printRef}>
//                 <UserCard cardData={selectedUser} getLibraryName={getLibraryName} />
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default LibraryUsersList;






// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { API_PATH } from "../../Constant/constant";
// import { useNavigate } from "react-router-dom";
// import * as Constants from "../../Constant/constant";
// import UserCard from "./Cards";
// import { useReactToPrint } from "react-to-print";

// const PAGE_SIZE = 10;

// const FilterRow = ({ filters, setFilters }) => (
//   <tr className="libraryCard mt-20">
//     <td></td>
//     <td>
//       <input
//         type="text"
//         placeholder="Name"
//         value={filters.name}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, name: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Email"
//         value={filters.email}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, email: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Mobile"
//         value={filters.mobile}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, mobile: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Unique ID"
//         value={filters.unique_id}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, unique_id: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td>
//       <input
//         type="text"
//         placeholder="Library Name"
//         value={filters.library_id}
//         onChange={(e) =>
//           setFilters((f) => ({ ...f, library_id: e.target.value }))
//         }
//         className="border px-2 py-1 rounded form-control form-control-sm"
//       />
//     </td>
//     <td></td>
//   </tr>
// );

// const LibraryUsersList = () => {
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [filters, setFilters] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     unique_id: "",
//     library_id: "",
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const navigate = useNavigate();
//   const [libraries, setLibraries] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);

//   // ✅ Move hooks ABOVE conditional returns
//   // const printRef = useRef();
//   // const handlePrint = useReactToPrint({
//   //   content: () => printRef.current,
//   //   documentTitle: "Library Card",
//   // });


//   const printRef = useRef();
// const handlePrint = useReactToPrint({
//   content: () => printRef.current,
//   documentTitle: "Library Card",
// });

// useEffect(() => {
//   if (selectedUser) {
//     handlePrint();
//   }
// }, [selectedUser]);

// const printLibraryCard = (user) => {
//   setSelectedUser(user);
// };

//   // Fetch all users
//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const res = await axios.get(`${API_PATH}/library_cards`);
//         setUsers(res.data);
//         setFilteredUsers(res.data);
//       } catch (err) {
//         console.error("❌ Error fetching users:", err);
//         setError("Failed to load users");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsers();
//   }, []);

//   // Fetch libraries once
//   useEffect(() => {
//     const fetchLibraries = async () => {
//       try {
//         const response = await axios.get(
//           Constants.API_PATH + `/add_new_library_data`
//         );
//         setLibraries(response.data);
//       } catch (error) {
//         console.error("Error fetching libraries:", error);
//         setError("Failed to fetch libraries.");
//       }
//     };

//     fetchLibraries();
//   }, []);

//   // Apply filters
//   useEffect(() => {
//     let filtered = users;

//     if (filters.name) {
//       filtered = filtered.filter((u) =>
//         `${u.first_name} ${u.last_name}`
//           .toLowerCase()
//           .includes(filters.name.toLowerCase())
//       );
//     }

//     if (filters.email) {
//       filtered = filtered.filter(
//         (u) =>
//           u.email &&
//           u.email.toLowerCase().includes(filters.email.toLowerCase())
//       );
//     }

//     if (filters.mobile) {
//       filtered = filtered.filter(
//         (u) =>
//           u.mobile_no &&
//           u.mobile_no.toString().includes(filters.mobile.toString())
//       );
//     }

//     if (filters.unique_id) {
//       filtered = filtered.filter(
//         (u) =>
//           u.unique_id &&
//           u.unique_id.toLowerCase().includes(filters.unique_id.toLowerCase())
//       );
//     }

//     if (filters.library_id) {
//       filtered = filtered.filter(
//         (u) =>
//           u.library_id &&
//           u.library_id
//             .toString()
//             .toLowerCase()
//             .includes(filters.library_id.toLowerCase())
//       );
//     }

//     setFilteredUsers(filtered);
//     setCurrentPage(1);
//   }, [filters, users]);

//   const totalPages = Math.ceil(filteredUsers.length / PAGE_SIZE);
//   const paginatedUsers = filteredUsers.slice(
//     (currentPage - 1) * PAGE_SIZE,
//     currentPage * PAGE_SIZE
//   );

//   if (loading) return <p className="text-gray-500">Loading users...</p>;
//   if (error) return <p className="text-red-600">{error}</p>;

//   const getLibraryName = (id) => {
//     const lib = libraries.find((library) => library.id === id);
//     return lib ? lib.library_name : "Unknown Library";
//   };



//   return (
//     <div className="container w-80 mw-80">
//       <h2 className="text-xl font-bold mb-4">📚 All Users</h2>
//       {filteredUsers.length === 0 ? (
//         <p className="text-gray-600">No users found.</p>
//       ) : (
//         <>
//           <table className="w-100 table-bordered border-collapse border shadow-md rounded-lg overflow-hidden">
//             <thead>
//               <tr className="bg-blue-600 text-white libraryCard">
//                 <th className="px-4 py-2">#</th>
//                 <th className="px-4 py-2">Name</th>
//                 <th className="px-4 py-2">Email</th>
//                 <th className="px-4 py-2">Mobile</th>
//                 <th className="px-4 py-2">Unique ID</th>
//                 <th className="px-4 py-2">Library Name</th>
//                 <th className="px-4 py-2">Actions</th>
//               </tr>
//               <FilterRow filters={filters} setFilters={setFilters} />
//             </thead>
//             <tbody>
//               {paginatedUsers.map((u, index) => (
//                 <tr key={u.id} className="hover:bg-gray-50">
//                   <td className="border border-gray-300 px-4 py-2">
//                     {(currentPage - 1) * PAGE_SIZE + index + 1}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.first_name} {u.last_name}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">{u.email}</td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.mobile_no}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {u.unique_id}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2">
//                     {getLibraryName(u.library_id)}
//                   </td>
//                   <td className="border border-gray-300 px-4 py-2 text-center">
//                     <button
//                       onClick={() => navigate(`/library-cards/${u.id}`)}
//                       className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 "
//                     >
//                       View Card
//                     </button>

//                     <button
//                       onClick={() => printLibraryCard(u)}
//                       className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
//                     >
//                       Print Card
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="flex justify-center items-center mt-4 gap-2">
//             <button
//               className="px-2 py-1 border rounded"
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage(currentPage - 1)}
//             >
//               Prev
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               className="px-2 py-1 border rounded"
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage(currentPage + 1)}
//             >
//               Next
//             </button>
//           </div>

//           <div style={{ display: "none" }}>
//             {selectedUser && (
//               <div ref={printRef}>
//                 <UserCard
//                   cardData={selectedUser}
//                   getLibraryName={getLibraryName}
//                 />
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default LibraryUsersList;






import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_PATH } from "../../Constant/constant";
import { useNavigate } from "react-router-dom";
import * as Constants from "../../Constant/constant";
import UserCard from "./Cards";
import { useReactToPrint } from "react-to-print";

const PAGE_SIZE = 10;

const FilterRow = ({ filters, setFilters }) => (
  <tr className="libraryCard mt-20">
    <td></td>
    <td>
      <input
        type="text"
        placeholder="Name"
        value={filters.name}
        onChange={(e) =>
          setFilters((f) => ({ ...f, name: e.target.value }))
        }
        className="border px-2 py-1 rounded form-control form-control-sm"
      />
    </td>
    <td>
      <input
        type="text"
        placeholder="Email"
        value={filters.email}
        onChange={(e) =>
          setFilters((f) => ({ ...f, email: e.target.value }))
        }
        className="border px-2 py-1 rounded form-control form-control-sm"
      />
    </td>
    <td>
      <input
        type="text"
        placeholder="Mobile"
        value={filters.mobile}
        onChange={(e) =>
          setFilters((f) => ({ ...f, mobile: e.target.value }))
        }
        className="border px-2 py-1 rounded form-control form-control-sm"
      />
    </td>
    <td>
      <input
        type="text"
        placeholder="Unique ID"
        value={filters.unique_id}
        onChange={(e) =>
          setFilters((f) => ({ ...f, unique_id: e.target.value }))
        }
        className="border px-2 py-1 rounded form-control form-control-sm"
      />
    </td>
    <td>
      <input
        type="text"
        placeholder="Library Name"
        value={filters.library_id}
        onChange={(e) =>
          setFilters((f) => ({ ...f, library_id: e.target.value }))
        }
        className="border px-2 py-1 rounded form-control form-control-sm"
      />
    </td>
    <td></td>
  </tr>
);

const LibraryUsersList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    mobile: "",
    unique_id: "",
    library_id: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [libraries, setLibraries] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  // Print setup
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Library Card",
  });

  const printLibraryCard = (user) => {
    setSelectedUser(user);
    // wait for component render before printing
    setTimeout(() => {
      handlePrint();
    }, 1000);
  };

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${API_PATH}/library_cards`);
        setUsers(res.data);
        setFilteredUsers(res.data);
      } catch (err) {
        console.error("❌ Error fetching users:", err);
        setError("Failed to load users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Fetch libraries once
  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await axios.get(
          Constants.API_PATH + `/add_new_library_data`
        );
        setLibraries(response.data);
      } catch (error) {
        console.error("Error fetching libraries:", error);
        setError("Failed to fetch libraries.");
      }
    };

    fetchLibraries();
  }, []);

  // Apply filters
  useEffect(() => {
    let filtered = users;

    if (filters.name) {
      filtered = filtered.filter((u) =>
        `${u.first_name} ${u.last_name}`
          .toLowerCase()
          .includes(filters.name.toLowerCase())
      );
    }

    if (filters.email) {
      filtered = filtered.filter(
        (u) =>
          u.email &&
          u.email.toLowerCase().includes(filters.email.toLowerCase())
      );
    }

    if (filters.mobile) {
      filtered = filtered.filter(
        (u) =>
          u.mobile_no &&
          u.mobile_no.toString().includes(filters.mobile.toString())
      );
    }

    if (filters.unique_id) {
      filtered = filtered.filter(
        (u) =>
          u.unique_id &&
          u.unique_id.toLowerCase().includes(filters.unique_id.toLowerCase())
      );
    }

    if (filters.library_id) {
      filtered = filtered.filter(
        (u) =>
          u.library_id &&
          u.library_id
            .toString()
            .toLowerCase()
            .includes(filters.library_id.toLowerCase())
      );
    }

    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [filters, users]);

  const totalPages = Math.ceil(filteredUsers.length / PAGE_SIZE);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  if (loading) return <p className="text-gray-500">Loading users...</p>;
  if (error) return <p className="text-red-600">{error}</p>;

  const getLibraryName = (id) => {
    const lib = libraries.find((library) => library.id === id);
    return lib ? lib.library_name : "Unknown Library";
  };

  return (
    <div className="container w-80 mw-80">
      <h2 className="text-xl font-bold mb-4">📚 All Users</h2>
      {filteredUsers.length === 0 ? (
        <p className="text-gray-600">No users found.</p>
      ) : (
        <>
          <table className="w-100 table-bordered border-collapse border shadow-md rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-600 text-white libraryCard">
                <th className="px-4 py-2">#</th>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Mobile</th>
                <th className="px-4 py-2">Unique ID</th>
                <th className="px-4 py-2">Library Name</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
              <FilterRow filters={filters} setFilters={setFilters} />
            </thead>
            <tbody>
              {paginatedUsers.map((u, index) => (
                <tr key={u.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">
                    {(currentPage - 1) * PAGE_SIZE + index + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {u.first_name} {u.last_name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">{u.email}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {u.mobile_no}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {u.unique_id}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {getLibraryName(u.library_id)}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    <button
                      onClick={() => navigate(`/library-cards/${u.id}`)}
                      className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 "
                    >
                      View Card
                    </button>

                    <button
                      onClick={() => printLibraryCard(u)}
                      className="ml-2 px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Print Card
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-4 gap-2">
            <button
              className="px-2 py-1 border rounded"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="px-2 py-1 border rounded"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          </div>

          {/* Hidden Print Section */}
          <div style={{ display: "none" }}>
            {selectedUser && (
              <div ref={printRef}>
                <UserCard
                  cardData={selectedUser}
                  getLibraryName={getLibraryName}
                />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default LibraryUsersList;



